export const PHONE_NUMBER_UPDATE_ERROR =
  'Phone number update was unsuccessful. Please try again.';
export const SMS_CREATE_ERROR =
  'SMS sign up was unsuccessful. Please try again.';
export const SMS_CREATE_SUCCESS = 'Your SMS sign up was successful.';
